import React from 'react'
import Form from '@blocks/Form'
import { ReactComponent as EmailIcon } from '@icons/email.svg'
import { Link } from 'react-router-dom'
import useTitle from '@hooks/useTitle'
import Button from '@components/blocks/Button'
import Input from '@components/blocks/Input'
import { route, notify } from '@helpers'
import api from '@api'
import useAuthTemplate from '@auth/components/template/hooks/useAuthTemplate'

export default function ForgotPage() {
    useTitle("Forgot?")
    useAuthTemplate({
        footer: <p><Link to={route("signin")}>Sign in</Link><span> or </span><Link to={route("signup")}>Sign up</Link></p>
    })

    return (
        <Form action={api.forgot} handleSuccess={() => notify("We sent a link to your email. Visit the link to reset the password.")} method="post">
            <Input id="email" type="email" height="l" name="email" placeholder="example@email.com" label="Email" required icon={<EmailIcon />} />
            <Button element="submit">Reset the password</Button>
        </Form>
    )
}